import React from 'react';
import './AICISNewYork.css';

const AICISNewYork = () => {
  return (
    <div className="newyork-page">
      {/* Hero Section - Premium New York */}
      <section 
        className="newyork-hero"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(10, 10, 30, 0.85) 0%, rgba(20, 20, 50, 0.7) 50%, rgba(10, 10, 30, 0.85) 100%), url('https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=1600&h=900&fit=crop')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="newyork-hero-overlay"></div>
        <div className="newyork-hero-content">
          <span className="newyork-badge">UNGA 81 WEEK</span>
          <h1>AICIS NEW YORK 2026</h1>
          <p className="newyork-subtitle">Africa Infrastructure, Climate Change, Security & Green Investment Summit</p>
          <div className="newyork-date-location">
            <span>📅 29–30 September 2026</span>
            <span>📍 New York City, USA</span>
          </div>
          <p className="newyork-theme">
            <strong>Theme:</strong> Harnessing Global Efforts for Infrastructure, Security and Climate Change Investment in Africa
          </p>
          <div className="newyork-stats">
            <div className="stat-item">
              <span className="stat-number">81</span>
              <span className="stat-label">UNGA Session</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">200+</span>
              <span className="stat-label">Expected Participants</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">50+</span>
              <span className="stat-label">Countries</span>
            </div>
          </div>
          <a href="#register" className="btn-ny">Register Now</a>
        </div>
      </section>

      {/* Mobilising Global Partnerships */}
      <section className="newyork-intro">
        <div className="container-ny">
          <h2>Mobilising Global Partnerships for Africa's Sustainable Future</h2>
          <p>
            As world leaders gather in New York for the <strong>81st Session of the United Nations General Assembly (UNGA 81)</strong>, 
            the Africa Business Ventures & Investment Group (ABVIG) proudly presents <strong>AICIS New York 2026</strong>—a premier 
            international investment and partnership forum dedicated to accelerating sustainable infrastructure development, 
            climate action, energy security, peace, industrialisation and economic transformation across Africa.
          </p>
          <p>
            Convened during UNGA Week, AICIS New York 2026 will bring together Heads of State and Government, Ministers, 
            United Nations agencies, diplomatic missions, multilateral development banks, development finance institutions, 
            sovereign wealth funds, global corporations, institutional investors, climate financiers, philanthropies, academia 
            and civil society to advance strategic dialogue and mobilise investment for Africa's future.
          </p>
          <p>
            The Forum is designed to transform global policy discussions into practical investment partnerships, bankable 
            projects and measurable development outcomes that support the <strong>Sustainable Development Goals (SDGs)</strong>, 
            the <strong>African Union Agenda 2063</strong> and Africa's long-term prosperity.
          </p>
        </div>
      </section>

      {/* Why New York - Premium */}
      <section className="newyork-why">
        <div className="container-ny">
          <div className="newyork-why-grid">
            <div className="newyork-why-text">
              <span className="section-badge-ny">Why New York?</span>
              <h2>The Diplomatic Capital of the World</h2>
              <p>
                New York serves as the diplomatic capital of the world during the annual United Nations General Assembly, 
                bringing together the largest concentration of political leaders, international organisations, investors 
                and development partners.
              </p>
              <p>
                Holding AICIS during UNGA Week provides an exceptional opportunity to:
              </p>
              <ul>
                <li>Engage with Heads of State and Government</li>
                <li>Connect with United Nations agencies and specialised institutions</li>
                <li>Mobilise international finance for Africa's infrastructure and climate priorities</li>
                <li>Showcase bankable investment opportunities</li>
                <li>Strengthen G2G, G2B and B2B partnerships</li>
                <li>Foster innovation, technology transfer and sustainable development</li>
                <li>Expand Africa's access to global capital markets and strategic investors</li>
              </ul>
            </div>
            <div className="newyork-why-image">
              <div className="newyork-why-image-box" style={{backgroundImage: "url('https://images.unsplash.com/photo-1522083165195-3424ed129620?w=600&h=400&fit=crop')"}}></div>
            </div>
          </div>
        </div>
      </section>

      {/* Why AICIS */}
      <section className="newyork-why-aicis">
        <div className="container-ny">
          <div className="newyork-why-aicis-content">
            <span className="section-badge-ny">Why AICIS?</span>
            <h2>Transforming Investment Opportunities into Action</h2>
            <p>
              Africa possesses immense economic potential but continues to face significant infrastructure deficits, 
              climate vulnerabilities, energy challenges and financing gaps.
            </p>
            <p>
              AICIS provides a high-level international platform where governments, investors, development institutions 
              and private-sector leaders collaborate to transform investment opportunities into implementable, 
              finance-ready projects.
            </p>
            <div className="focus-areas-ny">
              <span>🏗️ Infrastructure Development</span>
              <span>🌍 Climate Change Adaptation</span>
              <span>⚡ Energy Security</span>
              <span>💰 Green Finance</span>
              <span>🌾 Food Security</span>
              <span>🏭 Industrialisation</span>
              <span>🕊️ Peace and Security</span>
              <span>💻 Digital Economy & AI</span>
              <span>📈 Regional Trade</span>
              <span>🤝 Public-Private Partnerships</span>
            </div>
          </div>
        </div>
      </section>

      {/* Our Global Legacy - Timeline */}
      <section className="newyork-legacy">
        <div className="container-ny">
          <span className="section-badge-ny">Our Global Legacy</span>
          <h2>Building Global Partnerships Across Continents</h2>
          <p className="legacy-intro">
            The Africa Business Ventures & Investment Group (ABVIG) has established a growing international record 
            of convening strategic investment, infrastructure and development forums that connect Africa with global partners.
          </p>

          <div className="legacy-timeline-ny">
            <div className="legacy-item-ny">
              <div className="legacy-icon-ny">🇬🇭</div>
              <div className="legacy-content-ny">
                <h3>Accra, Ghana</h3>
                <p className="legacy-sub-ny">The Foundation of Regional Engagement</p>
                <p>ABVIG's international conference journey began in Accra, Ghana, where it successfully organised high-level conferences at the Chisco Hotel and the Tang Palace Hotel, Roman Ridge.</p>
                <p className="legacy-highlight-ny">Established ABVIG as a respected platform for promoting investment and strategic partnerships across West Africa.</p>
              </div>
            </div>

            <div className="legacy-item-ny">
              <div className="legacy-icon-ny">🇺🇸</div>
              <div className="legacy-content-ny">
                <h3>Arlington, Virginia, USA</h3>
                <p className="legacy-sub-ny">Connecting Africa with Global Investors</p>
                <p>ABVIG expanded its international footprint by convening the Africa Infrastructure, Climate Change & Green Investment Summit (AICIS) at the Hyatt Regency Crystal City at Reagan National Airport.</p>
                <p className="legacy-highlight-ny">Strengthened ABVIG's engagement with the international development community.</p>
              </div>
            </div>

            <div className="legacy-item-ny">
              <div className="legacy-icon-ny">🇳🇬</div>
              <div className="legacy-content-ny">
                <h3>Abuja, Nigeria</h3>
                <p className="legacy-sub-ny">Africa's Flagship Investment Platform</p>
                <p>Nigeria has become the principal home of the Africa Infrastructure, Climate Change, Security & Green Investment Summit (AICIS).</p>
                <p className="legacy-highlight-ny">One of Africa's leading platforms for mobilising investment and fostering strategic partnerships.</p>
              </div>
            </div>

            <div className="legacy-item-ny">
              <div className="legacy-icon-ny">🗽</div>
              <div className="legacy-content-ny">
                <h3>New York, USA</h3>
                <p className="legacy-sub-ny">The Next Phase of Global Engagement</p>
                <p>AICIS New York 2026 represents the next milestone in ABVIG's international journey, convened during UNGA Week.</p>
                <p className="legacy-highlight-ny">Connecting Africa with world leaders, UN agencies, and global investors.</p>
              </div>
            </div>
          </div>

          <div className="legacy-journey-ny">
            <h4>Our Global Journey</h4>
            <div className="journey-grid-ny">
              <div className="journey-item-ny">
                <span className="journey-country-ny">🇬🇭 Ghana</span>
                <span className="journey-venue-ny">Accra</span>
                <span className="journey-milestone-ny">Regional investment conferences</span>
              </div>
              <div className="journey-item-ny">
                <span className="journey-country-ny">🇺🇸 USA</span>
                <span className="journey-venue-ny">Arlington, VA</span>
                <span className="journey-milestone-ny">International expansion</span>
              </div>
              <div className="journey-item-ny">
                <span className="journey-country-ny">🇳🇬 Nigeria</span>
                <span className="journey-venue-ny">Abuja</span>
                <span className="journey-milestone-ny">Flagship investment summit</span>
              </div>
              <div className="journey-item-ny">
                <span className="journey-country-ny">🇺🇸 USA</span>
                <span className="journey-venue-ny">New York</span>
                <span className="journey-milestone-ny">UNGA 81 Week Forum</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Objectives */}
      <section className="newyork-objectives-ny">
        <div className="container-ny">
          <span className="section-badge-ny">Our Goals</span>
          <h2>Objectives</h2>
          <div className="objectives-grid-ny">
            <div className="objective-item-ny">
              <span className="objective-icon-ny">💰</span>
              <p>Mobilise global investment for Africa</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">📊</span>
              <p>Promote investment-ready projects</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">🤝</span>
              <p>Strengthen strategic international partnerships</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">🗣️</span>
              <p>Facilitate policy dialogue</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">🌿</span>
              <p>Expand access to climate finance</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">🏗️</span>
              <p>Accelerate infrastructure development</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">⚡</span>
              <p>Promote energy transition</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">💡</span>
              <p>Encourage technology transfer</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">🕊️</span>
              <p>Strengthen peace and economic resilience</p>
            </div>
            <div className="objective-item-ny">
              <span className="objective-icon-ny">🌍</span>
              <p>Advance implementation of the SDGs</p>
            </div>
          </div>
        </div>
      </section>

      {/* UN Engagement */}
      <section className="newyork-un-ny">
        <div className="container-ny">
          <div className="newyork-un-content-ny">
            <span className="section-badge-ny">United Nations Engagement</span>
            <h2>Engagement with the United Nations System</h2>
            <p>
              During UNGA Week, ABVIG will engage with relevant United Nations agencies, programmes and specialised 
              institutions to strengthen collaboration in sustainable development, climate action, infrastructure 
              financing, energy, innovation and economic transformation.
            </p>
            <p>
              ABVIG also seeks to establish long-term institutional partnerships that contribute to the implementation 
              of the Sustainable Development Goals across Africa. Where eligible and in accordance with United Nations 
              policies and procedures, ABVIG intends to pursue appropriate consultative and partnership opportunities 
              within the UN system, including engagement toward consultative status with the 
              <strong> United Nations Economic and Social Council (ECOSOC)</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* Expected Participants */}
      <section className="newyork-participants-ny">
        <div className="container-ny">
          <span className="section-badge-ny">Who Will Attend</span>
          <h2>Expected Participants</h2>
          <div className="participants-grid-ny">
            <div className="participant-category-ny">
              <span className="category-icon-ny">👑</span>
              <h4>Government & Diplomacy</h4>
              <ul>
                <li>Heads of State and Government</li>
                <li>Ministers</li>
                <li>Ambassadors and Permanent Representatives</li>
                <li>African Union Institutions</li>
              </ul>
            </div>
            <div className="participant-category-ny">
              <span className="category-icon-ny">🏛️</span>
              <h4>International Organizations</h4>
              <ul>
                <li>United Nations Agencies</li>
                <li>Multilateral Development Banks</li>
                <li>Development Finance Institutions</li>
                <li>Climate Finance Institutions</li>
              </ul>
            </div>
            <div className="participant-category-ny">
              <span className="category-icon-ny">💼</span>
              <h4>Private Sector</h4>
              <ul>
                <li>Global Corporations</li>
                <li>Institutional Investors</li>
                <li>Sovereign Wealth Funds</li>
                <li>Chambers of Commerce</li>
              </ul>
            </div>
            <div className="participant-category-ny">
              <span className="category-icon-ny">🌍</span>
              <h4>Civil Society & Academia</h4>
              <ul>
                <li>Philanthropic Foundations</li>
                <li>Universities and Research Institutions</li>
                <li>Civil Society Organisations</li>
                <li>Youth and Women Leaders</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Expected Outcomes */}
      <section className="newyork-outcomes-ny">
        <div className="container-ny">
          <span className="section-badge-ny">What We'll Achieve</span>
          <h2>Expected Outcomes</h2>
          <div className="outcomes-grid-ny">
            <div className="outcome-item-ny">✅ Strategic investment partnerships</div>
            <div className="outcome-item-ny">✅ Memoranda of Understanding (MoUs)</div>
            <div className="outcome-item-ny">✅ Investment commitments</div>
            <div className="outcome-item-ny">✅ Climate finance partnerships</div>
            <div className="outcome-item-ny">✅ Public-Private Partnership (PPP) initiatives</div>
            <div className="outcome-item-ny">✅ Technology collaboration</div>
            <div className="outcome-item-ny">✅ Bankable project pipelines</div>
            <div className="outcome-item-ny">✅ Stronger Africa–global cooperation</div>
            <div className="outcome-item-ny">✅ Enhanced engagement with international partners</div>
            <div className="outcome-item-ny">✅ Roadmap linking AICIS New York 2026 to AICIS Africa 2026</div>
          </div>
        </div>
      </section>

      {/* About ABVIG */}
      <section className="newyork-about-ny">
        <div className="container-ny">
          <div className="about-abvig-content-ny">
            <span className="section-badge-ny">About ABVIG</span>
            <h2>Africa Business Ventures & Investment Group</h2>
            <p>
              The Africa Business Ventures & Investment Group (ABVIG) is an international investment promotion, 
              project development and strategic partnership organisation dedicated to mobilising finance, innovation 
              and collaboration for Africa's sustainable development.
            </p>
            <p>
              Through the Africa Infrastructure, Climate Change, Security & Green Investment Summit (AICIS), 
              ABVIG convenes governments, development institutions, investors, businesses and policy leaders to 
              accelerate transformative projects that promote infrastructure development, climate resilience, 
              energy security, industrialisation, regional integration and inclusive economic growth.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="register" className="newyork-cta-ny">
        <div className="container-ny">
          <div className="cta-content-ny">
            <h2>Join the Global Movement</h2>
            <p>
              Connect. Partner. Invest. Transform Africa.
            </p>
            <p className="cta-sub-ny">
              Join governments, investors, development institutions, business leaders and global partners in New York 
              as we shape the future of Africa through strategic partnerships, sustainable investment and transformative action.
            </p>
            <div className="cta-buttons-ny">
              <button className="btn-ny-primary" onClick={() => window.location.href = '/partnership-collaboration'}>
                Register Now
              </button>
              <button className="btn-ny-secondary" onClick={() => window.location.href = '/partnership-collaboration'}>
                Partner With Us
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AICISNewYork;